import React from 'react';
import { RouteComponentProps } from 'react-router';
import { UserState, LayoutProps, } from '../interface/MyInterfaces';
import { NewEmployeeReportState } from '../interface/NewEmployeeReportInterface';
import { EarlyCareerReportState } from '../interface/EarlyCareerReportInterface';

import { downloadNewEmployeeReportData } from '../actions/NewEmployeeReportActions';
import { handleFilterSelection } from '../actions/EarlyCareerReportActions';


import { isAgg, getVintageFromReportType } from './common/Helpers';
import { saveAs } from 'file-saver';

import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';
import { bindActionCreators } from 'redux';

import { clearSharedLink } from '../actions/UserActions';

import SharedLinkForm from './Reports/SharedLinkForm';
import { EmployeeReportPdfContext, CaptureEmployeeReportPdfFn } from './Reports/NewEmployeeReport/EmployeeReportPdfContext';
import { authHeader } from "../javascript/auth-header";

import styled from "styled-components";
import { ReportText, TextLink, TextRouteLink, Heading3 } from './Common/SharedStyledComponents';
import { IrisColors } from '../css/IRISColors';
import { Col, Row } from 'react-bootstrap';
import { filterECRHeading_AndComparison, filterECRHeading } from "./Reports/EarlyCareerReport/elements/helpers";
import { ecrFilterValues, compareMeasure } from './reports/earlycareerreport/elements/helpers.js'



interface CleanReportLayoutProps {
    UserState?: UserState;
    EarlyCareerReportState?: EarlyCareerReportState;
    NewEmployeeReportState?: NewEmployeeReportState;
    clearSharedLink?();
    downloadNewEmployeeReportData?: any;
    handleFilterSelection?: any;
}

interface CleanReportLayoutState {
    isNational_FromParent?: any;
    showModal?: any;
    classShrink?: any;
    currentDateTime?: any;
    downloadWasCalled?: boolean;
    dataAllLoaded?: boolean;
}

export class CleanReportLayout extends React.Component<CleanReportLayoutProps & LayoutProps & RouteComponentProps<{}>, CleanReportLayoutState> {
    private capturePdf: CaptureEmployeeReportPdfFn | null = null;

    constructor(props) {
        super(props);
        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();

        this.state = {
            showModal: false,
            classShrink: false,
            currentDateTime: currentDate,
            downloadWasCalled: false,
            dataAllLoaded: false
        };
        this.handleDownloadPDF = this.handleDownloadPDF.bind(this);
        this.savePDF = this.savePDF.bind(this);
        this.handleDownloadFiles = this.handleDownloadFiles.bind(this);
        this.handleOpenSharedLink = this.handleOpenSharedLink.bind(this);
        this.closeShareWindow = this.closeShareWindow.bind(this);
        this.doClick = this.doClick.bind(this);
        this.dataFinishedLoading = this.dataFinishedLoading.bind(this);
        this.registerCapture = this.registerCapture.bind(this);
    }

    registerCapture(fn: CaptureEmployeeReportPdfFn | null) {
        this.capturePdf = fn;
    }

    closeShareWindow() {
        this.setState({
            showModal: false
        });

    }

    handleOpenSharedLink() {
        this.setState({
            showModal: true
        });
        this.props.clearSharedLink();
    }

    handleDownloadFiles() {
        var report_type = this.props.match.path.split('/')[2];
        if (report_type === "employee-report") {
            this.props.downloadNewEmployeeReportData(this.props.NewEmployeeReportState);
        } 
    }

    async savePDF(controller) {
        var report_type = this.props.match.path.split('/')[2];
        let url = "", fileName= "";
        var currentDateTime = this.state.currentDateTime;
        var display_id = this.props.UserState.report_display_id;

        var obj = {};
        obj["display_id"] = display_id;
        obj["currentDateTime"] = currentDateTime;
        obj["vintage"] = getVintageFromReportType(report_type, this.props.UserState);

        if (report_type == "early-career-report") {
            const { EarlyCareerReportBasicInfo, EarlyCareerReportFilterSavedValues, Suborgs } = this.props.EarlyCareerReportState;
            const university =
                (this.props.UserState.report_university_name == undefined) ? this.props.UserState.report_university_name_initial : this.props.UserState.report_university_name;

            url = "/IRISReportsMicroservice/api/PDF/EarlyCareerReportPDF/generate_pdf";
            fileName = 'EarlyCareerReport_' + currentDateTime + '.pdf'
            obj["university"] = university;
            obj["start_year"] = EarlyCareerReportBasicInfo.start_year;
            obj["end_year"] = EarlyCareerReportBasicInfo.end_year;
            obj["filterECRHeading_AndComparison"] = filterECRHeading_AndComparison(EarlyCareerReportFilterSavedValues, Suborgs);
            obj["filterECRHeading"] = filterECRHeading(EarlyCareerReportFilterSavedValues, Suborgs)
            obj["journal_ranks"] = this.props.EarlyCareerReportState.JournalRankData;
            obj["journal_ranks_2"] = this.props.EarlyCareerReportState.JournalRankData_2;
            obj["compareMeasure"] = compareMeasure(this.props.EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
        }
        else {
            var university = this.props.NewEmployeeReportState.EmployeeProfileInfo.university;
            url = "/IRISReportsMicroservice/api/PDF/NewEmployeeReportPDF/generate_pdf";
            fileName = 'EmployeeReport_' + currentDateTime + '.pdf';

            obj["employeeRelease"] = this.props.NewEmployeeReportState.employeeRelease;
            obj["university"] = university;
            obj["selectedStateCode"] = this.props.NewEmployeeReportState.selectedStateCode ?? "0";
            obj["state_text"] = this.props.NewEmployeeReportState.state_text;
            obj["state_text2"] = this.props.NewEmployeeReportState.state_text2;
            obj["state_text3"] = this.props.NewEmployeeReportState.state_text3;
            obj["isAgg"] = isAgg(display_id);
            obj["EmployeeMethodology"] = this.props.NewEmployeeReportState.EmployeeMethodology;
            obj["EmployeeNationalLocation"] = this.props.NewEmployeeReportState.EmployeeNationalLocation;
        }
        var headers = authHeader();
        headers.append('Accept', 'application/json'); // This one is enough for GET requests
        headers.append('Content-Type', 'application/json'); // This one sends body
        const res = await fetch(url, { method: 'POST', body: JSON.stringify(obj), headers: headers });
        if (!res.ok) {
            throw new Error("PDF generation failed");
        }
        const blob = await res.blob();
        saveAs(blob, fileName);
    }

    handleDownloadPDF = () => async (e) => {
        if (this.state.downloadWasCalled) return;

        this.setState({
            downloadWasCalled: true
        });

        try {
            var report_type = this.props.match.path.split('/')[2];
            if (report_type === "employee-report") {
                if (!this.capturePdf) {
                    alert("Open the Employee Profile Report to download the PDF.");
                    return;
                }
                await this.capturePdf();
            }
            await this.savePDF("NewEmployeeReport");
        } catch (error) {
            console.log(error);
            alert("Could not generate the PDF. Wait for the report to finish rendering and try again.");
        } finally {
            this.setState({ downloadWasCalled: false });
        }
    }

    doClick() {
        this.props.handleFilterSelection("toggleMenu", false);
    }

    dataFinishedLoading() {
        const { no_compare, ecr_award_compare, gender_compare } = this.props.EarlyCareerReportState?.EarlyCareerReportFilterSavedValues;
        const { EarlyCareerReportBasicInfo, Suborgs, EarlyCareerReportFilterCounts, SankeyData, EarlyCareerReportAwardCount, EarlyCareerReportAwardCount_2, GrantData, GrantData_2, TeamData, TeamData_2, POEData, POEData_2 } = this.props.EarlyCareerReportState;

        if (
            ((no_compare && (!EarlyCareerReportBasicInfo || !Suborgs || !EarlyCareerReportFilterCounts || !SankeyData || !EarlyCareerReportAwardCount || !GrantData || !TeamData || !POEData)) ||
                ((ecr_award_compare || gender_compare) && (!SankeyData || !EarlyCareerReportAwardCount || !GrantData || !TeamData || !POEData || !EarlyCareerReportAwardCount_2 || !GrantData_2 || !TeamData_2 || !POEData_2)))
        )
            return false;
        else
            return true;
    }

    public render() {
        const iris_logo = require('../images/IRISLogo_Large.png');
        const iris_logo_blue = require('../images/IRISLogo_Portal_small.png');
        const iris_logo_white = require('../images/IRIS_Logo_White.png');

        var notShared = true;
        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        if (sharedLinkPageOnLoad) {
            notShared = false;
        }
        var report_type = this.props.match.path.split('/')[2];
        let logoUni;
        try {
            logoUni = require(`../images/univ_logos/${this.props.UserState.report_display_id}.png`);
        }
        catch (err) {
            console.log(err)
        }
        const { url } = this.props.match;
        let university = (report_type == "employee-report") ? this.props.NewEmployeeReportState?.EmployeeProfileInfo?.university :
            //this.props.EarlyCareerReportState?.EarlyCareerReportBasicInfo?.university;
            (this.props.UserState.report_university_name == undefined) ? this.props.UserState.report_university_name_initial : this.props.UserState.report_university_name;

        const { Suborgs, SuborgsDefined } = this.props.EarlyCareerReportState;
        const theValues = this.props.EarlyCareerReportState.EarlyCareerReportFilterSavedValues;
        //console.log(this.props.EarlyCareerReportState);
        const ecr_award = theValues.ecr_award.map(x => {
            const displayValue = ecrFilterValues("ecr_award", x);
            return <p className="from-me">{displayValue}</p>
        });

        const gender = theValues.gender.map(x => {
            const displayValue = ecrFilterValues("gender", x);
            return <p className="from-me">{displayValue}</p>
        });

        const funder = theValues.funder.map(x => {
            const displayValue = ecrFilterValues("funder", x);
            return <p className="from-me">{displayValue}</p>
        });

        const suborg = theValues.suborg.map(x => {
            const displayValue = ecrFilterValues("suborg", x, Suborgs, SuborgsDefined);
            return <p className="from-me">{displayValue}</p>
        });
        //console.log('toggleMenu');
        //if (this.props.EarlyCareerReportState && this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection)
        //    console.log(this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection.toggleMenu);

        return (
            <EmployeeReportPdfContext.Provider value={{ registerCapture: this.registerCapture }}>
            <LayoutContainer>
                <SharedLinkForm reportType={report_type} showModal={this.state.showModal} handleClose={this.closeShareWindow} />
                <Header>
                    <Col lg={12} md={12} style={{ padding:0, height: "100px" }}>
                        <HeaderContent>
                            <LogoBanner>
                                <HeaderGroup>
                                    <IrisLogoContainer>
                                        <HeaderImage src={String(iris_logo_white)} alt='IRIS Logo' />
                                    </IrisLogoContainer>
                                    <h1>{university}</h1>
                                </HeaderGroup>
                                {/*<HeaderImage src={String(logoUni)} alt='University Logo' />*/}
                            </LogoBanner>
                            <Row>
                                {(!sharedLinkPageOnLoad || (sharedLinkPageOnLoad &&
                                    this.props.UserState.sharedLinkEmailSubmitted)) &&
                                    <Col lg={3} md={3}>
                                        <ReportText bold center>
                                            <TextLink
                                                color={IrisColors.white}
                                                onClick={this.state.downloadWasCalled ? undefined : this.handleDownloadPDF()}
                                                style={this.state.downloadWasCalled ? { opacity: 0.7, pointerEvents: 'none' } : undefined}
                                            >
                                                <i className='glyphicon glyphicon-save'></i> {this.state.downloadWasCalled ? 'GENERATING PDF...' : 'DOWNLOAD PDF'}
                                            </TextLink>
                                        </ReportText>
                                    </Col>
                                }
                                {(!sharedLinkPageOnLoad || (sharedLinkPageOnLoad &&
                                    this.props.UserState.sharedLinkEmailSubmitted)) &&
                                    report_type != "early-career-report" &&
                                    <Col lg={3} md={3}>
                                    <ReportText bold center><TextRouteLink color={IrisColors.white} to={`${url}/methodology`}><i className='glyphicon glyphicon-file'></i> METHODOLOGY</TextRouteLink></ReportText>
                                    </Col>
                                }
                                {notShared &&
                                    <Col lg={3} md={3} >
                                        <ReportText bold center><TextLink color={IrisColors.white} onClick={this.handleOpenSharedLink}><i className='glyphicon glyphicon-link'></i> SHARE REPORT</TextLink></ReportText>
                                    </Col>
                                }
                                {notShared &&
                                    report_type != "early-career-report" &&
                                    <Col lg={3} md={3} >
                                        <ReportText bold center><TextLink color={IrisColors.white} onClick={this.handleDownloadFiles}><i className='glyphicon glyphicon-save'></i> DOWNLOAD DATA</TextLink></ReportText>
                                    </Col>
                                }
                            </Row>
                        </HeaderContent>
                    </Col>
                    {
                        this.props.EarlyCareerReportState &&
                        this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection &&
                        this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection.toggleMenu &&
                        this.dataFinishedLoading() &&
                        <div id="ecr_topMenu" onClick={() => this.doClick()}>
                            <Heading3 color="black" className="filtersToggleHeading">Filters</Heading3>
                            {ecr_award}
                            {gender}
                            {funder}
                            {suborg}
                            <span style={{ color: "gray", float: "right", fontSize: "18px", cursor: "pointer" }}><i className='glyphicon glyphicon-chevron-up'></i></span>
                        </div>
                    }
                </Header>

                {this.props.children}
                <Footer>
                    <ReportText>© {new Date().getFullYear()} Institute for Research on Innovation and Science (IRIS). All rights reserved.</ReportText>
                </Footer>
            </LayoutContainer>
            </EmployeeReportPdfContext.Provider>
        );
    }
}

const LayoutContainer = styled.main` 
    margin: 0 auto;
    width: 1300px;
    display: grid;
    grid-gap: 0px;
    min-height: 84vh;
`;

const Header = styled.div`
    position: sticky;
    top: 0;
    width: 1300px;
    max-height: 600px;
    color: white;
    z-index: 1;
    background: white;
`;

const HeaderContent = styled.div`
    max-width: max(100%, 1200px);
    margin-inline: auto;
    background: ${IrisColors.irisLogoBlue};
    padding: 0;
`;

const HeaderGroup = styled.div`
    display: flex;
`;

const LogoBanner = styled.div`
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding-block: 10px;
    border-bottom: solid white 2px;
`;

const HeaderImage = styled.img`
    height: 45px;
`;

const IrisLogoContainer = styled.div`
    padding-right: 20px;
    margin-right: 20px;
    border-right: solid white 2px;
`;

const Footer = styled.div`
    display: grid;
    width: 100%;
    place-items: center;
    background: ${IrisColors.grey};
    text-align: center;
    color: white;
    padding-inline: 5px;
    margin-top: auto;
`;

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            clearSharedLink: clearSharedLink,
            downloadNewEmployeeReportData: downloadNewEmployeeReportData,
            handleFilterSelection: handleFilterSelection
        }, dispatch
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    NewEmployeeReportState: state.newEmployeeReportProperties,
    EarlyCareerReportState: state.earlyCareerReportProperties,
    UserState: state.userProperties,
});


export default connect(mapStateToProps, matchDispatchToProps)(CleanReportLayout);


